import { Action } from '@ngrx/store';

export enum EConfirmationAddressActions {
  VisibilityConfirmationAddress = '[Confirmation Address] Visibility address confirmation',
}

export class VisibilityConfirmationAddress implements Action {
  public readonly type = EConfirmationAddressActions.VisibilityConfirmationAddress;
  constructor(public payload: boolean) {}
}

export type ConfirmationAddressActions = VisibilityConfirmationAddress;
